import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private msalService: MsalService) {}

  login(): void {
    this.msalService.loginRedirect();
  }

  logout(): void {
    this.msalService.logoutRedirect();
  }

  userInfo() {
    const userInfo: AccountInfo = this.msalService.instance.getAllAccounts()[0];
    return userInfo;
  }

  get email(): string {
    return this.userInfo().username;
  }

  get aliasName(): string | null {
    const userInfo = this.userInfo();
    return userInfo && userInfo?.username
      ? userInfo.username.substring(
          0,
          userInfo.username.indexOf('@') + ''.length
        )
      : null;
  }

  get isAuthenticated(): boolean {
    return this.msalService.instance.getAllAccounts()[0] != undefined;
  }
}
